// ============================================================================
// Constants
// ============================================================================

import { defaultFont } from "src/nhweb-shared/theme/fonts";

// Breakpoints
export const BREAKPOINTS = {
  SM: "375px",
  MD: "768px",
  LG: "1024px"
};

// Colors
export const COLORS = {
  NEUTRAL_300: "#6E6E6E",
  NEUTRAL_500: "#424242",
  LINK_BLUE: "#0074C2",
  LINK_BLUE_HOVER: "#EFF8FC",
  BG_COLOR: "#FAFBFC",
  BORDER_COLOR: "#DEE5EC",
  WHITE: "#FFFFFF",
  DISABLED: "#BDBDBD",
  POSITIVE_MUTED: "#F0F8F0",
  POSITIVE_BASE: "#178019",
  PRIMARY_MUTED: "#EFF8FC",
  PRIMARY_BASE: "#0074C2",
  PRIMARY_500: "#1998D5",
  PRIMARY_600: "#1476AD",
  SECONDARY_MUTED: "#FDEFE6",
  SECONDARY_PRESS: "#9C4308",
  CONTENT_MUTED: "#ECECEC",
  TERTIARY_BORDER_DEEP: "#81919F"
};

// Typography
export const TYPOGRAPHY = {
  // Body styles
  BODY_SMALL_MEDIUM: `
    font-family: ${defaultFont};
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
  `,

  BODY_NORMAL_LIGHT: `
    font-family: ${defaultFont};
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
  `,

  BODY_LARGE_LIGHT: `
    font-family: ${defaultFont};
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
  `,

  BODY_NORMAL_REGULAR: `
    font-family: ${defaultFont};
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  `,

  BODY_NORMAL_MEDIUM: `
    font-family: ${defaultFont};
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
  `,

  BODY_LARGE_MEDIUM: `
    font-family: ${defaultFont};
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  `,

  BODY_LARGE_BOLD: `
    font-family: ${defaultFont};
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
  `,

  P_BOLD_MOBILE: `
    font-family: ${defaultFont};
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  `,

  P_DESKTOP: `
    font-family: ${defaultFont};
    font-size: 20px;
    font-weight: 300;
    line-height: 30px;
  `,

  P_BOLD_DESKTOP: `
    font-family: ${defaultFont};
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
  `,

  // Button styles
  BUTTON_NORMAL_BOLD: `
    font-family: ${defaultFont};
    font-size: 14px;
    font-weight: 700;
    line-height: 24px;
  `,

  // Text link styles
  TEXTLINK_NORMAL_MEDIUM: `
    font-family: ${defaultFont};
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-decoration: underline;
  `,

  // Heading styles
  H1_MOBILE: `
    font-family: ${defaultFont};
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
  `,

  H1_DESKTOP: `
    font-family: ${defaultFont};
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
  `,

  H2_MOBILE: `
    font-family: ${defaultFont};
    font-size: 28px;
    font-weight: 500;
    line-height: 42px;
  `,

  H2_DESKTOP: `
    font-family: ${defaultFont};
    font-size: 42px;
    font-weight: 500;
    line-height: 54px;
  `,

  HEADING_NORMAL_MEDIUM: `
    font-family: ${defaultFont};
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
  `,

  HEADING_LARGE: `
    font-family: ${defaultFont};
    font-size: 32px;
    font-weight: 500;
    line-height: 42px;
  `,

  HEADING_XLARGE_MEDIUM: `
    font-family: ${defaultFont};
    font-size: 42px;
    font-weight: 500;
    line-height: 54px;
  `
};

export const ROWS_PER_PAGE = 10;
